import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {Template} from '../../domain/template';

@Injectable()
export class TemplateService {
    
    readonly TEMPLATE_URL = environment.backendUrl + '/brain-monitor/api/templates';
    
    constructor(private http: HttpClient) {
    }
    
    getTemplates(pageIndex: number,
                 pageSize: number,
                 filters: any,
                 sort: string
                ): Observable<any> {
    
        let httpParams = new HttpParams()
            .set('page', pageIndex.toString())
            .set('size', pageSize.toString());
        
        if (filters && Object.keys(filters).length > 0) {
            for (const key in filters) {
                httpParams = httpParams.set(key + '.' + filters[key].matchMode, filters[key].value);
            }
        }
    
        httpParams = httpParams.set('sort', sort);
        
        return this.http.get<any>(this.TEMPLATE_URL, {params: httpParams});
    }
    
    saveTemplate(template: Template): Observable<any> {
        return this.http.post<any>(this.TEMPLATE_URL, template);
    }
    
    deleteTemplate(template: Template): Observable<any> {
        return this.http.delete<any>(this.TEMPLATE_URL.concat('/').concat(template.id.toString()));
    }
    
    updateTemplate(template: Template): Observable<any> {
        return this.http.put<any>(this.TEMPLATE_URL, template);
    }
}
